import React, { useState, useEffect } from "react";
import { Grid, TextField, Button } from "@material-ui/core";
import { Search as SearchIcon } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import userActions from "../../../redux/actions/users";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";

export default function Search() {
  const [search, setSearch] = useState("");
  const users = useSelector((state) => state.users);
  const dispatch = useDispatch();

  useEffect(() => setSearch(users.search), [users.search]);

  const handleSubmit = () => {
    dispatch(userActions.setSearch({ search }));
  };
  return (
    <Grid
      container
      alignItems="center"
      style={{ marginBottom: 10 }}
      justify="space-between"
      direct="row"
    >
      <Grid item>
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <TextField
              variant="outlined"
              margin="dense"
              placeholder="nombre, apellido, email, teléfono"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              style={{ height: 40, marginTop: 3 }}
              onClick={() => handleSubmit()}
              startIcon={<SearchIcon />}
            >
              Buscar
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <Grid item>
        <ToggleButtonGroup
          value={users.userTypes}
          onChange={(e, userTypes) =>
            dispatch(userActions.setUsertypes(userTypes))
          }
          size="small"
        >
          <ToggleButton value="GREENPOINT" aria-label="GREENPOINT">
            Monitores
          </ToggleButton>
          <ToggleButton value="ADMIN" aria-label="ADMIN">
            Administradores
          </ToggleButton>
          <ToggleButton value="" aria-label="">
            Libres
          </ToggleButton>
        </ToggleButtonGroup>
      </Grid>
    </Grid>
  );
}
